import { TimelineView } from '@/components/shared/timeline'
import { useTimelineQuery } from '@/services/timeline'
import { Alert, Box, CircularProgress } from '@mui/material'

interface MedRequestTimelineProps {
  medRequestId: string
  medicationName: string
}

export default function MedRequestTimeline({ medRequestId, medicationName }: MedRequestTimelineProps) {
  const { data: events = [], isLoading, isError } = useTimelineQuery(medRequestId, 'medication_request')

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (isError) {
    return (
      <Alert severity='error' sx={{ mx: 2 }}>
        Failed to load timeline. Please try again later.
      </Alert>
    )
  }

  return (
    <TimelineView
      entityName={medicationName}
      events={events}
      totalItems={events.length}
      itemsPerPage={12}
      excludedFilters={['Patient', 'Order', 'Investigations', 'Tasks']}
    />
  )
}
